(function() {
  const drawer = document.getElementById('cart-drawer');
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const cartUrl = (path) => `${ROOT.replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;

  if (!drawer) return;

  const panel = drawer.querySelector('[data-cart-drawer-panel]');
  const itemsList = drawer.querySelector('#cart-line-items');
  const emptyState = drawer.querySelector('#cart-empty');
  const subtotalEl = drawer.querySelector('#cart-subtotal');
  const tmpl = drawer.querySelector('#cart-item-template');

  // Util: format money (fallback if Shopify.formatMoney unavailable)
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(
          cents,
          window.theme && theme.settings && theme.settings.money_format
            ? theme.settings.money_format
            : '${{amount}}'
        );
      }
    } catch(e) {}
    const n = (cents / 100);
    return new Intl.NumberFormat(
      undefined,
      { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }
    ).format(n);
  }

  // Open / close
  function openDrawer() {
    drawer.classList.remove('tw-hidden');
    requestAnimationFrame(() => {
      panel.classList.remove('tw-translate-x-full');
      drawer.setAttribute('aria-hidden', 'false');
      panel.focus();
    });
  }
  function closeDrawer() {
    panel.classList.add('tw-translate-x-full');
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(() => drawer.classList.add('tw-hidden'), 300);
  }

  // Events
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      refreshCart().then(openDrawer);
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // ESC to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && !drawer.classList.contains('tw-hidden')) {
      closeDrawer();
    }
  });

  // Fetch & render cart
  async function fetchCart() {
    const res = await fetch(cartUrl('cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' });

    if (!res.ok) throw new Error('Failed to load cart');
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!res.ok) throw new Error('Failed to update line');
    const cart = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }

  function renderCart(cart) {
    itemsList.innerHTML = '';
    if (!cart.items.length) {
      emptyState.classList.remove('tw-hidden');
      subtotalEl.textContent = formatMoney(0);
      return;
    }
    emptyState.classList.add('tw-hidden');

    cart.items.forEach((item) => {
      const node = tmpl.content.cloneNode(true);
      const hrefs = node.querySelectorAll('[data-href]');
      hrefs.forEach((a) => (a.href = item.url));
      const img = node.querySelector('[data-image]');
      if (img) {
        img.src = (item.image && item.image) || item.featured_image?.url || '';
        img.alt = item.title;
      }
      node.querySelector('[data-title]').textContent = item.product_title || item.title;
      node.querySelector('[data-variant]').textContent = item.variant_title || '';

      const qtyInput = node.querySelector('[data-qty]');
      qtyInput.value = item.quantity;
      const price = (item.final_line_price != null ? item.final_line_price : item.line_price);
      node.querySelector('[data-line-price]').textContent = formatMoney(price);

      node.querySelector('[data-remove]').addEventListener('click', async (e) => {
        e.preventDefault();
        await changeLine(item.key, 0).then(renderCart);
      });

      node.querySelector('[data-increment]').addEventListener('click', async () => {
        const next = Number(qtyInput.value) + 1;
        qtyInput.value = next;
        await changeLine(item.key, next).then(renderCart);
      });

      node.querySelector('[data-decrement]').addEventListener('click', async () => {
        const next = Math.max(0, Number(qtyInput.value) - 1);
        qtyInput.value = next;
        await changeLine(item.key, next).then(renderCart);
      });

      qtyInput.addEventListener('change', async () => {
        const next = Math.max(0, Number(qtyInput.value || 0));
        await changeLine(item.key, next).then(renderCart);
      });

      itemsList.appendChild(node);
    });

    subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
  }

  async function refreshCart() {
    const cart = await fetchCart();
    renderCart(cart);
    return cart;
  }

  // Listen for global cart updates (open theme compatibility)
  document.addEventListener('cart:refresh', () => refreshCart());
  document.addEventListener('cart:updated', (e) => renderCart(e.detail.cart));

  // Intercept add-to-cart (optional): add data attribute to forms you want handled via AJAX
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add-to-cart]');
    if (!form) return;

    e.preventDefault();

    const formData = new FormData(form);
    const res = await fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    if (!res.ok) {
      let err;
      try { err = await res.json(); } catch(e) {}
      console.error('Add to cart failed!!', err || res.status);
      return;
    }

    await refreshCart();
    openDrawer();
  });

  // Optional: auto-render on load
  // refreshCart();

})();
